<template>
    <app-layout title="Rechten">
        <template #header>
            <page-title title="Rechten" />
        </template>

        <template #pageContent>
            <div id="permissions" >
                <Input type="search" placeholder="Recht zoeken" v-model="searchPermission" name="search-permission"/>
                <Table id="permissions-overview" :values="filteredPermissions">
                    <thead>
                    <Th id="name">Naam</Th>
                    <Th id="description">Omschrijving</Th>
                    <Th id="slug">Slug</Th>
                    <Th  :sort="false">Rollen</Th>
                    <Th id="inheritable">Los toekenbaar</Th>
                    <Th id="updated_at">Laatste wijziging</Th>
                    <Th :sort="false" class="text-right">
                        <Button
                            htmlType="a"
                            buttonClass="add"
                            size="small"
                            title="Recht toevoegen"
                            text="Recht toevoegen"
                            :href="route('admin.permissions.create')"
                        />
                    </Th>
                    </thead>
                    <tbody v-if="filteredPermissions.length > 0">
                        <tr v-for="permission in state.sortedValues['permissions-overview']" :key="permission.id">
                            <Td v-if="permission.deleted_at" class="line-through">{{ permission.name }}</Td>
                            <Td v-else>{{ permission.name }}</Td>
                            <Td>{{ permission.description }}</Td>
                            <Td>{{ permission.slug }}</Td>
                            <Td>
                                <template v-for="role in permission.roles">
                                    <badge :text="role.name" v-if="role.slug == 'admin'" badgeClass="danger"/>
                                    <badge :text="role.name" v-else-if="role.slug == 'it'" badgeClass="warning"/>
                                    <badge :text="role.name" v-else-if="role.level > 0" badgeClass="dark"/>
                                    <badge :text="role.name" v-else badgeClass="light"/>
                                </template>
                            </Td>
                            <Td>{{ permission.assignable }}</Td>
                            <Td>{{ moment(permission.updated_at).format('DD/MM/YYYY HH:mm') }}</Td>
                            <Td class="text-right">
                                <Button
                                    htmlType="a"
                                    buttonClass="show"
                                    size="small"
                                    title="Recht bekijken"
                                    text="Recht bekijken"
                                    :href="route('admin.permissions.show', {'id':permission.id})"
                                /><br>
                                <Button
                                    htmlType="a"
                                    buttonClass="edit"
                                    size="small"
                                    title="Recht aanpassen"
                                    text="Recht aanpassen"
                                    :href="route('admin.permissions.edit', {'id':permission.id})"
                                    v-if="permission.deleted_at === null"
                                />
                            </Td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Input from '@/Components/Input.vue'
import Badge from '@/Components/Badge.vue'
import store from '@/store'
import moment from "moment";
import { ref } from 'vue'
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Table,
        Td,
        Th,
        Button,
        Input,
        Badge,
    },
    props:[
        'permissions'
    ],
    data() {
        return {
            searchPermission: '',
        };
    },
    setup (props){
        return {
            state: store.state,
            ...store,
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
        filteredPermissions(){
            return this.permissions.filter(permission => {
                return permission.name.toLowerCase().includes(this.searchPermission.toLowerCase()) ||
                    permission.slug.toLowerCase().includes(this.searchPermission.toLowerCase()) ||
                    (permission.description && permission.description.toLowerCase().includes(this.searchPermission.toLowerCase()))
            })
        },
    },
}

</script>
